export const ODONTO_AVAILABLE_TIMES_STALE_TIME = 3 * 60 * 1000; // 3 minutes
